(function(){
    'use strict';
    angular.module('Services')
        .factory('PaymentGatewayService', function($http, $rootScope, Error, Request, $filter){
            return {
                PaymentGateway: {
                    getAll: function(callback, errCallback, data) {
                        Request.get({
                            url: ApiURLs.paymentGateway.gateway,
                            successCallback: callback,
                            errorCallback: errCallback,
                            data: data
                        });
                    },
                    supportedPaymentGateway: function(callback, errCallback, data) {
                        Request.get({
                            url: ApiURLs.paymentGateway.supportedPaymentGateway,
                            successCallback: callback,
                            errorCallback: errCallback,
                            data: data
                        })
                    },
                    createPaymentGateway: function(callback, errCallback, payload) {
                        Request.post({
                            url: ApiURLs.paymentGateway.gateway,
                            method: 'POST',
                            successCallback: callback,
                            errorCallback: errCallback
                        }, payload);
                    },
                    paymentGatewayDetails: function(callback, errCallback, id) {
                        Request.get({
                            url: ApiURLs.paymentGateway.paymentGatewayDetails.replace(':id', id),
                            successCallback: callback,
                            errorCallback: errCallback
                        });
                    },
                    updatePaymentGatewayDetails: function(callback, errCallback, id, payload) {
                        Request.post({
                            url: ApiURLs.paymentGateway.paymentGatewayDetails.replace(':id', id),
                            method: 'PUT',
                            successCallback: callback,
                            errorCallback: errCallback
                        }, payload);
                    }
                }
            };
        });
})()



// WEBPACK FOOTER //
// ./js/services/PaymentGatewayService.js